import {DialogFragment, DialogFragmentProps, DialogFragmentState} from "../shared/PageFragment";
import React, {ReactElement} from "react";
import {StyledBoxColumn, StyledBoxRow, StyledSpan} from "../shared/StyledComponents";
import {DIVIDER_BLACK, PAGE_FRAGMENT_WIDTH, PD_LG} from "../shared/dimens";
import {Button, Typography} from "@mui/material";
import {BaseApp} from "../shared/BaseApp";
import {AppPrefs} from "./app_prefs";

export class TutorialHelper {

  static showTutorial(onStartup?: boolean): void {
    if (onStartup && AppPrefs.getInstance().getTutorial()) {
      return;
    }
    AppPrefs.getInstance().setTutorial(true);
    BaseApp.CONTEXT.showDialog(null, () => <TutorialFragment onStartup={Boolean(onStartup)}/>);
  }
}

type TutorialFragmentProps = DialogFragmentProps & {
  onStartup?: boolean,
}

type TutorialFragmentState = DialogFragmentState & {
  page: number,
}

type Page = {
  html: string,
}

const PAGES: Page[] = [
  {
    html: "<h1>HELLO</h1>" +
      "Welcome to Codabot.<p/>" +
      "Tap buttons for commands e.g. FD 50 to move forward 50 steps, or LT 15 to turn left by 15 degrees.<p/>" +
      "Then tap the <b>Enter</b> button to add command to the code window.<p/>" +
      "Then tap <b>Click to RUN (DRAW)</b> button.<p/>" +
      "Tap <b>Next</b> to continue...<p/>",
  },
  {
    html: "<h1>STEP 1</h1>" +
      "Tap <b>Commands</b> in the first column on the left.<p/>" +
      "Then Tap <b>Values</b> in the second column on the left.<p/>" +
      "A forward line of 100 pixels is FD 100.<p/>" +
      "Tap FD, then tap 1, 0, 0.<p/>" +
      "Click <b>Enter</b> button to add it to your code.<p/>",
  },
  {
    html: "<h1>STEP 2</h1>" +
      "Now you should see FD 100 in the code window.<p/>" +
      "Tap the <b>Click to RUN (DRAW)</b> button to execute!<p/>" +
      "While running, tap the <b>STOP</b> button to stop execution.<p/>",
  },
  {
    html: "<h1>TIPS</h1>" +
      "You can tap multiple commands, e.g. FD 100 LT 15.<p/>" +
      "Tap the <b>DEL</b> button delete the current command, and again to remote the last command.<p/>" +
      "Click <b>PEN 6</b> to choose Blue color for the pen.<p/>" +
      "Click <b>SETBG 1</b> to choose Light Yellow color for the background.<p/>" +
      "Use <b>REPEAT #times...END</b> for loops.<p/>" +
      "Click <b>Gallery</b> to view a list of examples with code.<p/>" +
      "Click <b>Reset</b> to reset Codabot.<p/>",
  },
];

class TutorialFragment extends DialogFragment<TutorialFragmentProps, TutorialFragmentState> {

  protected onCreateState(): TutorialFragmentState {
    return {
      ...super.onCreateState(),
      page: 0,
    };
  }

  private renderInContainer(title: string, children: ReactElement): ReactElement {
    return <StyledBoxColumn style={{padding: PD_LG,}}>
      <Typography><b>{title}</b></Typography>
      {children}
    </StyledBoxColumn>;
  }

  renderContent(): ReactElement {
    return <StyledBoxColumn style={{width: "90vw", maxWidth: PAGE_FRAGMENT_WIDTH, gap: 0}}>
      <StyledBoxRow style={{padding: PD_LG, alignItems: "center", borderBottom: DIVIDER_BLACK}}>
        <Typography variant={"h5"}>Tutorial</Typography>
      </StyledBoxRow>
      <StyledBoxColumn style={{padding: PD_LG}}>
        {this.renderInContainer(`Page ${this.state.page + 1} of ${PAGES.length}`, <Typography
          dangerouslySetInnerHTML={{__html: PAGES[this.state.page].html}}/>)}
      </StyledBoxColumn>
      <StyledBoxRow style={{padding: PD_LG, alignItems: "center", borderTop: DIVIDER_BLACK}}>
        {this.props.onStartup
          ? <Button onClick={() => BaseApp.CONTEXT.hideDialog()}>Skip</Button>
          : null}
        <StyledSpan/>
        {this.state.page < PAGES.length - 1
          ? <Button onClick={() => this.setState({page: this.state.page + 1})} variant={"contained"}>Next</Button>
          : <Button onClick={() => BaseApp.CONTEXT.hideDialog()} variant={"contained"}>Finish</Button>}
      </StyledBoxRow>
    </StyledBoxColumn>;
  }
}